import { useState, useEffect } from 'react'

// Bootstrap
import Container from 'react-bootstrap/Container'

// React responsive
import { useMediaQuery } from 'react-responsive'

// Helpers
import fontSize from '../../helpers/fontSize'

// Components
import SquareButton from '../buttons/SquareButton'

// Images
import MainBannerImage from '../../assets/images/landing_page/main_banner/Cloudxier-mainbanner.png'

function HomeMainBanner() {

  const smallScreen = useMediaQuery({ query: '(max-width: 1023px)' })

  const [animateBannerTitle, setAnimateBannerTitle] = useState(false)

  // Start banner title animation on page load
  useEffect(() => {
    setAnimateBannerTitle(true)
  }, [])

  return (
    <div>
      <div style={styles.homeMainBannerContainer}>
        <div style={{
          ...styles.homeMainBannerTextContainer,
          opacity: animateBannerTitle ? 1 : 0,
          marginTop: animateBannerTitle ? 0 : '-50vh'
        }}>
          <div style={styles.homeMainBannerTextFlexContainer}>
            <Container style={{ padding: smallScreen ? '0 10vw' : 0 }}>
              <div
                style={{
                  ...styles.homeMainBannerTitle,
                  fontSize: smallScreen ? fontSize.heading1Sm : fontSize.heading1Lg,
                  marginBottom: smallScreen ? '30px' : '60px'
                }}>
                Your Partner in Digital Transformation
              </div>
              <div
                style={{
                  fontSize: smallScreen ? fontSize.heading3Sm : fontSize.heading3Lg,
                  marginBottom: smallScreen ? '30px' : '60px'
                }}>
                We provide end-to-end technology solutions for your business, {smallScreen ? null : <br />} help you drive growth and positive impact in the future.
              </div>
              <div style={styles.homeMainBannerActionButton}>
                <SquareButton
                  action={() => window.open('/contact-us', '_self')}
                  textColor='#4C39FF'
                  hoverTextColor='white'
                  text='Discuss with us'
                  textSize={smallScreen ? fontSize.bodySm : fontSize.bodyLg}
                  backgroundColor='white'
                  hoverBgColor='#4C39FF'
                  width={smallScreen ? '150px' : '200px'}
                />
              </div>
            </Container>
          </div>
        </div>
        <div style={styles.bannerOverlay} />
        <img src={MainBannerImage} style={styles.homeMainBanner} alt='main-banner' />
      </div>
    </div>
  )

}

export default HomeMainBanner

const styles = {
  container: {
    padding: '0 20px'
  },
  homeMainBannerContainer: {
    width: '100%',
    height: '100vh'
  },
  homeMainBanner: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  bannerOverlay: {
    backgroundColor: 'rgba(0,0,0,0.3)',
    width: '100%',
    height: '100vh',
    position: 'absolute',
    zIndex: 1
  },
  homeMainBannerTextContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    color: 'white',
    zIndex: 2,
    transition: 'opacity 2s, margin 1s'
  },
  homeMainBannerTextFlexContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  },
  homeMainBannerTitle: {
    fontWeight: '500',
  },
  homeMainBannerActionButton: {
    color: 'blue',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center'
  }
}